import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import jwt_decode from "jwt-decode";
import { Provider } from "react-redux";
import IdleTimer from "react-idle-timer";
import moment from "moment";

import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import { authActions } from "./redux/actions";
import Navigation from "./router/Navigation";
import setAuthToken from "./utils/setAuthToken";
import store from "./redux/store/store";
import { authSessionPusher } from "./utils/pusher";
import isEmpty from "./validation/isEmpty";
import { types } from "./redux/type";

const App = () => {
  const idleTimer = useRef();
  const loginType = localStorage.loginType;

  const handleOnIdle = (event) => {
    if (localStorage.cmcAttendanceJwtToken) {
      console.log("Logout because of IDLE Screen");
      const sessionId = localStorage.loginSessionId;
      const lastActiveOn = moment(
        idleTimer.current.getLastActiveTime()
      ).format();
      // store.dispatch(
      //   authActions.onIdleScreen(sessionId, lastActiveOn, loginType)
      // );
      console.log(sessionId, lastActiveOn, loginType);
    }
  };

  useEffect(() => {
    const empty = isEmpty(loginType);
    const emptySessionId = isEmpty(localStorage.loginSessionId);
    (async () => {
      if (localStorage.cmcAttendanceJwtToken) {
        setAuthToken(localStorage.cmcAttendanceJwtToken);
        const decoded = jwt_decode(
          localStorage.cmcAttendanceJwtToken
        );
        store.dispatch(authActions.setCurrentUser(decoded));
        const currentTime = Date.now();
        if (decoded.exp * 1000 < currentTime) {
          store.dispatch(authActions.logoutUser());
        }
        if (empty || emptySessionId) {
          store.dispatch(authActions.logoutUser());
        } else {
          store.dispatch(
            authActions.checkIfSessionValid(
              localStorage.loginSessionId,
              loginType
            )
          );
          authSessionPusher(localStorage.loginSessionId);
        }
      }
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            localStorage.setItem("latitude", latitude);
            localStorage.setItem("longitude", longitude);
          },
          (error) => {
            const errorData = {
              data: error,
              status: error.code
            };
            store.dispatch({
              type: types.AuthTypes.AUTH_GET_ERRORS,
              payload: errorData
            });
          }
        );
      }
      // const publicIpAdd = await publicIpv4();
      // localStorage.setItem(
      //   "publicIpAdd",
      //   !isEmpty(publicIpAdd) ? publicIpAdd : "0.0.0.0"
      // );
      localStorage.setItem("publicIpAdd", "0.0.0.0");
    })();
  }, []);

  return (
    <Provider store={store}>
      <IdleTimer
        ref={idleTimer}
        onIdle={handleOnIdle}
        debounce={250}
        timeout={1000 * 60 * 30}
      />
      <Navigation />
    </Provider>
  );
};

export default App;
